import { required, maxLength } from 'vuelidate/lib/validators';
import { SECTION_TYPES } from '../../../../values/sections';
import EdInputModel from '../../../../../models/ed-input.model';
import EdFormModel from '../../../../../models/ed-form.model';
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';
import { Status } from '@/models/status.model';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { Project } from '@/courses/models/project.model';

@Component({
  name: 'ed-project-creator'
})
export default class EdProjectCreator extends Mixins(CreateObjectsMixin) {

  @Prop() readonly courseId: number;
  @Prop() readonly classId: number;

  public form: any = null;
  public saving: boolean = false;
  public status: Status = new Status();

  get title() {
    if(this.editionMode) {
      return `${this.$i18n.t('lesson.editTitle')}: ${this.project.name}`; 
    } else {
      if(this.project) {
        return `${this.$i18n.t('lesson.addTitleTo')} ${this.project.name}`;
      } else {
        return this.$i18n.t('lesson.addTitle');
      }
    }
  }

  get course() {
    return this.getCourseFromStore({courseId: this.courseId , classId: this.classId});
  }

  get editionMode() {
    return this.course.component.edition;
  }

  get project(): Project {
    return this.course.component.section;
  }

  get projectId() {
    return this.project ? this.project.projectId : null;
  }

  init(name: string = '') {
    this.form = EdFormModel([
      EdInputModel('name', name, {
        required,
        maxLength: maxLength(60)
      },
        name ? true : false
      )
    ]);
  }

  cancel() {
    // window.location.href = `${KEYS.CONTEXT}/createCourse?id=${this.courseId}`;
  }

  async createProject() {
    if(!this.editionMode) {
      try {
        this.saving = true;
        let id = await this .$Courses.Store.createProjectA({
          name: this.form.name.value,
          type: SECTION_TYPES.PROJECT.code,
          parentId: this.projectId,
          courseId: this.courseId,
          classId: this.classId
        })
        // let titleID = `${KEYS.PRE_PROJECT_ID}${id}`;
        this.form.set('name', '');
        // ToolService.scrollTo(KEYS.ED_RESUME_TREE_ID, document.getElementById(titleID).offsetTop);
        this.saving = false;
      } catch(err) {
        this.$EdToast.create({ 
          msg:  `${this.$t('courses.errors.errorSavingObject')}`,
          type: TOAST_TYPES.DANGER,
          top: '3rem',
          timeout: 3000
        });
        this.saving = false;
      }
    } else {
      this.updateProject();
    }
  }

  async updateProject() {
    let data: any = { ...this.project };
    data.name = this.form.name.value;
    data.classId = this.classId;
    this.saving = true;
    try{
      await this.$Courses.Store.updateProjectA(data);
    } catch(error){
      this.$EdToast.create({ 
        msg:  `${this.$t('courses.errors.errorSavingObject')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    } finally {
      this.saving = false;
    }
  }

  setData() {
    this.status.setLoading();
    if(this.editionMode) {
      this.init(
        this.project.name
      );
    } else {
      this.init();
    }
    this.status.setLoad();
  }

  created() {
    this.setData();
  }

  @Watch('project', { deep: true, immediate: false })
  sectionChanged() {
    this.setData(); 
  }

}
